import React from 'react'
import styles from './styles.module.css'
import caretDown from '../../../../../../img/caretDownGeneric.svg'
import { taxonomyLevel3Values } from './TaxonomyLevel3Values'

import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../../images/circle-info-regular-full.svg'

function Taxonomy3 ({ localTaxonomyLevel3, setLocalTaxonomyLevel3 }) {
  const handleTaxonomyChange = event => {
    setLocalTaxonomyLevel3(event.target.value.toLowerCase())
  }

  return (
    <div className={styles.taxonomyLevel3InputWrapper}>
      <div className={styles.inlineLabel}>
        <label className={styles.taxonomyLevel3Label}>Taxonomy (level 3)</label>
        <Tooltip
          title='Filter by third-level product taxonomy. Options depend on the selected level 2 category.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Taxonomy (level 3) help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>
      
      <div>
        <select
          className={styles.taxonomyLevel3DropBox}
          name='taxonomyLevel3'
          id='taxonomyLevel3'
          value={localTaxonomyLevel3}
          onChange={handleTaxonomyChange}
        >
          <option value=''>Select level 2</option>
          {taxonomyLevel3Values.map((value, index) => (
            <option key={index} value={value.toLowerCase()}>
              {value}
            </option>
          ))}
        </select>
        <img
          src={caretDown}
          alt='arrow'
          className={styles.taxonomyLevel3CustomArrow}
        />
      </div>
    </div>
  )
}

export default Taxonomy3
